import { createAction } from 'signin-app/redux/helpers';
const domain = 'EMPLOYEE_CHECKIN_IN';
export const { action: selectLeaveHours } = createAction(`${domain}/SELECT_LEAVE_HOURS`, (hours) => ({ hours }));
export const { action: selectLeaveMinutes } = createAction(`${domain}/SELECT_LEAVE_MINUTES`, (minutes) => ({
    minutes,
}));
export const { action: selectGroup } = createAction(`${domain}/SELECT_GROUP`, (groupId) => ({ groupId }));
export const { action: resetLeave } = createAction(`${domain}/RESET_LEAVE`, () => null);
export const { action: checkInEmployee, success: checkInEmployeeSuccess, failed: checkInEmployeeFailed, } = createAction(`${domain}/CHECKIN`, (accessToken, employeeId, pin, selectedHour, selectedMinute, groupId, successMessage) => ({
    accessToken,
    employeeId,
    pin,
    selectedHour,
    selectedMinute,
    groupId,
    successMessage,
}), response => ({ response }), (error) => ({ error }));
